import React, { useState, useCallback, useEffect } from "react";
import { usePermissionContext } from "../../contexts/permission-context";
import Filter from "../../components/Filter/Filter";
import {
    fetchAPIData,
    getCompanyId,
    getToken,
    getUser,
    //compareNameIgnoreCase,
    copyToClipboard,
    cleanObject,
    generateHiddenColumns,
    //PermissionsCheck,
    hasPermission,
    assetsManage,
    assetsPermissionOptions,
    assetsUseManageOptions,
    createFilterOptions, createSortFieldOptions
} from '../../Utils/Common';
import { handleSave } from '../../components/FormDialog/FormDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CopyIcon from '@mui/icons-material/AddToPhotosOutlined';
import IconButton from '@mui/material/IconButton';
import { Typography } from "@mui/material";
import Table, { renderCellExpand } from '../../components/Table/Table';
import { GridActionsCellItem } from "@mui/x-data-grid";
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import ActionDialog from "../../components/Dialogs/ActionDialog";
import ConfirmDialog from "../../components/Dialogs/ConfirmDialog";
import axios from 'axios';
import "../pages.scss";
import { usePersistentStorage } from "../../Utils/usePersistentStorage";
import Ajv from "ajv";

import CoreDocumentTypePropertiesPanel from './CoreDocumentTypePropertiesPanel';
const documentTypeSchemaRequired = require("../../json/coreDocumentTypeSchema.json").create.required;
const documentTypeSchemaOptional = require("../../json/coreDocumentTypeSchema.json").create.optional;
const documentTypeSchemaUpdateRequired = require("../../json/coreDocumentTypeSchema.json").update.required;
const documentTypeSchemaUpdateOptional = require("../../json/coreDocumentTypeSchema.json").update.optional;

const ajv = new Ajv({ strict: false });


const CoreDocumentTypesTabPanel = ({ setNotify, coreDocumentType, setCoreDocumentType }) => {
    const { permissions } = usePermissionContext();
    const [apiData, setApiData] = useState([]);
    const [rowJsonData, setRowJsonData] = useState({});
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState('view');  // default to view mode
    const [readOnly, setReadOnly] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmProps, setConfirmProps] = useState({});

    const formId = 'DocumentTypeDialog';

    const [reload, setReload] = useState(false);

    const [isLoading, setIsloading] = useState(false);

    // const initialSnackbarState = {
    //     open: false,
    //     message: '',
    //     alertTitle: '',
    //     severity: 'info',
    //     hideDuration: 1000
    // };

    // const [notify, setNotify] = useState(
    //     initialSnackbarState
    // );

    // API URL is dynamic in that COMPANY_ID is replaced
    const apiURL = '/api/companies/%COMPANY_ID%/documentTypes?';

    const totalLabel = "Matching Document Types";
    const saveButtonText = "Save Document Type";

    const fieldData = [
        'companyId', 'name', 'documentTypeId', 'label', 'description',
        'createdDate', 'modifiedDate'
    ];

    const hasAssetsManage = hasPermission(permissions, assetsManage);
    const hasAssetsUseManage = hasPermission(permissions, assetsUseManageOptions);

    const sortFieldData = [
        {
            field: 'companyId',
            label: 'Company ID'
        },
        {
            field: 'documentTypeId',
            label: 'Document Type ID'
        },
        {
            field: 'name',
            label: 'Name'
        },
        {
            field: 'label',
            label: 'Label'
        },
        {
            field: 'description',
            label: 'Description'
        },
        {
            field: 'createdDate',
            label: 'Created Date'
        },
        {
            field: 'modifiedDate',
            label: 'Modified Date'
        }
    ];


    const columns = [
        // {
        //     field: 'id',
        //     type: 'number',
        //     headerName: 'ID',
        //     hide: true,
        //     minWidth: 50,
        //     maxWidth: 50,
        //     flex: 1,
        //     headerAlign: 'left',
        //     align: 'left',
        // },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            hideable: false,
            minWidth: 130,
            maxWidth: 130,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            getActions: (params) => getActionButtons(params)
        },
        {
            field: 'companyId',
            hideable: false,
            headerName: 'Company ID',
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                return params.value.toString();
            }
        },
        {
            field: 'documentTypeId',
            hideable: false,
            headerName: 'Document Type ID',
            minWidth: 325,
            maxWidth: 325,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (
                    <div className="guidContent">
                        <div style={{ width: '275px' }}>
                            {params.value}
                        </div>
                        {params.value &&
                            <div>
                                <Tooltip title="Copy to clipboard" arrow placement="right">
                                    <IconButton aria-label="copy document Type ID" onClick={(event) => copyToClipboard(event, params.row.documentTypeId)}>
                                        <CopyIcon sx={{ fontSize: 'small' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            field: 'name',
            hideable: false,
            headerName: 'Name',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            // renderCell: renderCellExpand,
            renderCell: (params) => {
                return (
                    <div className="guidContent">
                        <div style={{ width: '110px' }}>
                            {params.value}
                        </div>
                        {params.value &&
                            <div>
                                <Tooltip title="Copy to clipboard" arrow placement="right">
                                    <IconButton aria-label="copy name" onClick={(event) => copyToClipboard(event, params.row.name)}>
                                        <CopyIcon sx={{ fontSize: 'small' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            field: 'description',
            hideable: false,
            headerName: 'Description',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'label',
            hideable: false,
            headerName: 'Label',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'attributes',
            hideable: false,
            headerName: 'Attributes',
            minWidth: 525,
            //maxWidth: 450,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            sortable: false,
            renderCell: (params) => {
                return (
                    <>
                        {params.value && (
                            <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
                                <table style={{ width: '475px', padding: '10px' }}>

                                    <tr>
                                        <th style={{ border: '1px solid #dddddd', textAlign: 'left' }}>Name</th>
                                        <th style={{ border: '1px solid #dddddd', textAlign: 'left' }}>Type</th>
                                        <th style={{ border: '1px solid #dddddd', textAlign: 'left' }}>Encrypted</th>
                                        <th style={{ border: '1px solid #dddddd', textAlign: 'left' }}>Category</th>
                                        <th style={{ border: '1px solid #dddddd', textAlign: 'left' }}>Label</th>
                                    </tr>
                                    {params.value && params.value.map((attr, index) => {
                                        return (

                                            <tr key={index}>
                                                <td style={{ border: '1px solid #dddddd', textAlign: 'left' }}>{attr.name}</td>
                                                <td style={{ border: '1px solid #dddddd', textAlign: 'left' }}>{attr.type}</td>
                                                <td style={{ border: '1px solid #dddddd', textAlign: 'left' }}>{attr.encrypted ? 'true' : 'false'}</td>
                                                <td style={{ border: '1px solid #dddddd', textAlign: 'left' }}>{attr.category}</td>
                                                <td style={{ border: '1px solid #dddddd', textAlign: 'left' }}>{attr.label}</td>
                                            </tr>

                                        );
                                    })}
                                </table>
                            </div>
                        )}
                    </>
                );
            }
        },

        {
            field: 'createdDate',
            headerName: 'Created Date',
            hide: true,
            minWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'modifiedDate',
            headerName: 'Modified Date',
            hide: true,
            minWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },


    ];

    const getColumns = () => {
        return (hasAssetsUseManage && columns) || columns.filter(obj => { return obj.field !== "actions" });
    };

    const toggleColumnPinning = () => {
        return (hasAssetsUseManage && 'columnPinning') || '';
    };

    const handleClickOpen = () => {

        let rowData = {};
        const JsonData = rowData;

        setRowJsonData(JsonData);

        setMode('create');

        setOpen(true);
        setReadOnly(false);
    };

    const [documentTypes, setDocumentTypes] = usePersistentStorage("coreDocumentTypes", []);

    useEffect(() => {
        if (coreDocumentType) {
            handleClickOpen();
        }
    }, [coreDocumentType]);

    useEffect(() => {
        // check if localstorge had data for the current tab
        setApiData(documentTypes);
    }, []);

    const fetchData = async (apiURL2, qparams) => {
        //console.log('inside fetch customer data:', qparams);

        /*
        let message = "Loading customer data ...";
    
        setNotify({
            isOpen: true,
            message: message,
            severity: 'info'
        });
    */
        setIsloading(true);
        await fetchAPIData(apiURL2, qparams)
            .then((data) => {
                // console.log("Updating table data: ", data);
                setApiData(data);
                setDocumentTypes(data);
                // clear the reload false now that data is loaded
                setReload(false);
                setIsloading(false);
            })
            .catch((err) => {
                console.log(err);

                let message = `Failed to load core document type data \n\n ${err.response.statusText} : ${err.response.data.message}`;
                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });

                // clear data since user may have previously loaded data that is already displayed
                setApiData([]);
                setReload(false);
                setIsloading(false);
            });
    };

    const viewRowData = (param, event) => {

        // remove the id from table data as table data only not part of json stored
        const {
            id,
            ...JsonData
        } = param.row;

        setRowJsonData(JsonData);
        setMode('view');
        setReadOnly(true);
        setOpen(true);
    };

    const viewEditData = useCallback((rowData) => () => {
        // console.log("view/edit icon clicked", rowData);

        // remove the id from table data as table data only not part of json stored
        const {
            id,
            ...JsonData
        } = rowData;

        setRowJsonData(JsonData);
        setMode('edit');
        setReadOnly(false);
        setOpen(true);
    }, []);


    const deleteDocumentType = (companyId, documentTypeId) => {

        let deleteUrl = `/api/companies/${companyId}/documentTypes/${documentTypeId}`;


        axios({
            method: "delete", url: deleteUrl,
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        })
            .then(response => {

                let message = `Deleted document Type[${documentTypeId}]`;

                setNotify({
                    isOpen: true,
                    message: message,
                    severity: 'info'
                });

                // do we need to reload??
                // console.log("current data: ", apiData);
                setApiData([]);
                setReload(true);

            }).catch(error => {
                console.log('error in delete document type api call:', error);

                let message = `Failed to delete core document type [${documentTypeId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });
            });
    };

    const deleteData = useCallback((rowData) => () => {
        // console.log("delete icon clicked", rowData);

        let documentTypeId = rowData.documentTypeId;
        let companyId = rowData.companyId;

        let title = "Delete Core Document Type";

        let msg =
            <>
                <Typography variant="body1" paragraph="true">
                    Are you sure you want to delete core document type ?
                </Typography>
                <Typography variant="body1" paragraph="true">
                    {`[${documentTypeId}]`}
                </Typography>
            </>

        let confirmProps = {
            title,
            msg,
            confirmCallback: () => deleteDocumentType(companyId, documentTypeId)
        };

        setConfirmProps(confirmProps);

        setConfirmOpen(true);

    }, []);


    const getActionButtons = (params) => {
        let actionButtons = [];


        // create edit button
        let editButton = <GridActionsCellItem icon={
            <Tooltip title="Edit" arrow placement="right">
                <EditIcon />
            </Tooltip>}
            label='View/Edit'
            onClick={viewEditData(params.row)}
        />;

        hasAssetsUseManage && actionButtons.push(editButton);


        let deleteButton = <GridActionsCellItem icon={
            <Tooltip title="Delete" arrow placement="right">
                <DeleteIcon />
            </Tooltip>}
            label='Delete'
            onClick={deleteData(params.row)}
        />;

        hasAssetsManage && actionButtons.push(deleteButton);


        return actionButtons;

    };

    const handleJsonChange = (formData) => {
        setRowJsonData(formData);
    };

    const handleClose = () => {
        setOpen(false);
        setCoreDocumentType(false)
    };

    const handleConfirmClose = () => {
        setConfirmOpen(false);
    };

    const handleFormChange = (data) => {
        setRowJsonData(data.formData);
    }

    const validateSchema = (documentTypeSchema, data) => {
        // console.log('got json schema', documentTypeSchema);
        const validate = ajv.compile(documentTypeSchema);
        const valid = validate(data);
        if (!valid) {
            console.log(validate.errors);
            return false;
        }
        return true;
    }

    const saveDocumentTypeData = (formData) => {

        // console.log('called save document type:', formData);
        // console.log('current mode:', mode);

        let cleanedObj = cleanObject(formData);

        if (mode === 'edit') {
            if (validateSchema(documentTypeSchemaUpdateRequired, cleanedObj)) {
                if (validateSchema(documentTypeSchemaUpdateOptional, cleanedObj)) {
                    // console.log('update core document type schema validated successfully..');
                    updateDocumentType(cleanedObj);
                }
                else {
                    console.log('update core document type schema validation failed for optional params..');
                    let message = `Update core document type schema validation failed for optional parameters`;

                    setNotify({
                        isOpen: true,
                        alertTitle: 'Schema Validation Failure',
                        message: message,
                        severity: 'error'
                    });
                }
            } else {
                console.log('update core document type schema validation failed..');
                let message = `Update core document type schema validation failed`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Schema Validation Failure',
                    message: message,
                    severity: 'error'
                });
            }
        }

        if (mode === 'create') {
            if (validateSchema(documentTypeSchemaRequired, cleanedObj)) {
                if (validateSchema(documentTypeSchemaOptional, cleanedObj)) {
                    // console.log('create schema validated successfully..');
                    createDocumentType(cleanedObj);
                }
                else {
                    console.log('create document type schema validation failed for optional params..');
                    let message = `Create core document type schema validation failed for optional parameters`;

                    setNotify({
                        isOpen: true,
                        alertTitle: 'Schema Validation Failure',
                        message: message,
                        severity: 'error'
                    });
                }
            }
            else {
                console.log('create schema validation failed..');
                let message = `Create core document type schema validation failed`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Schema Validation Failure',
                    message: message,
                    severity: 'error'
                });
            }

            // reset flag all the time on success or failure
            setCoreDocumentType(false);
        }
    }

    const updateDocumentType = (data) => {
        try {
            // console.log('inside document type update api..');

            let updateUrl = `/api/companies/${data.companyId}/documentTypes/${data.documentTypeId}`;

            axios({
                method: "put",
                url: updateUrl,
                data: data,
                headers: { 'insightUserId': getUser(), 'companyId': getCompanyId(), 'Authorization': getToken() }
            })
                .then(response => {
                    if (response.status === 200) {
                        let message = `Updated core document type [${data.documentTypeId}]`;

                        setNotify({
                            isOpen: true,
                            message: message,
                            severity: 'info'
                        });

                        //setApiData([]);
                        setReload(true);

                        // console.log('got response from core document type update:', response);
                        setOpen(false);
                    }

                }).catch(error => {
                    let message = `Failed to update core document type data \n\n ${error.response.statusText} : ${error.response.data.message}`;
                    setNotify({
                        isOpen: true,
                        alertTitle: 'Request failed',
                        message: message,
                        severity: 'error'
                    });
                    console.log('error in update core document type api call:', error.response.data.message);
                });
        }
        catch (e) {
            console.log(e);
            let message = `Failed to update core document type data `;
            setNotify({
                isOpen: true,
                alertTitle: 'Request failed',
                message: message,
                severity: 'error'
            });
        }
    }

    const createDocumentType = (data) => {
        try {
            // console.log('inside document type create api..');

            let createUrl = `/api/companies/${data.companyId}/documentTypes`;

            axios({
                method: "post",
                url: createUrl,
                data: data,
                headers: { 'insightUserId': getUser(), 'companyId': getCompanyId(), 'Authorization': getToken() }
            })
                .then(response => {
                    if (response.status === 200) {
                        let message = `Created core document type [${response.data.name}]`;

                        setNotify({
                            isOpen: true,
                            message: message,
                            severity: 'info'
                        });

                        //setApiData([]);
                        setReload(true);

                        // console.log('got response from core document type create:', response);
                        setOpen(false);
                    }

                }).catch(error => {

                    let message = `Failed to create core document type data \n\n ${error.response.statusText} : ${error.response.data.message}`;
                    setNotify({
                        isOpen: true,
                        alertTitle: 'Request failed',
                        message: message,
                        severity: 'error'
                    });
                    console.log('error in create core document type api call:', error.response.data.message);
                });
        }
        catch (e) {
            console.log(e);
        }
    }

    const getSchema = (mode) => {
        if (mode === 'create') {
            return [documentTypeSchemaRequired, documentTypeSchemaOptional];
        } else if (mode === 'edit') {
            return [documentTypeSchemaUpdateRequired, documentTypeSchemaUpdateOptional];
        } else {
            // in view mode should be readonly so just choose update schema.
            // may want to create a view schema
            return [documentTypeSchemaUpdateRequired, documentTypeSchemaUpdateOptional];
        }
    };

    return (
        <>

            {/* <AlertSnackbar
                notify={notify}
                setNotify={setNotify} /> */}

            {/* <div id="documentTypeHeaderContainer" className="headerContainer">
                <div id="documentTypeHeader" className="documentTypeHeaderContainer">
                    <div id="content-left" className="content-left">
                        <div id="documentTypePageTitle" className="documentTypePageTitle">Core Document Types</div>
                        {hasAssetsManage &&
                            <div id="subhead" className="subhead">
                                <Button variant="text" endIcon={<AddBoxIcon color="primary" />} className="subheadText" onClick={handleClickOpen}>Create Core Document Type</Button>
                            </div>
                        }


                    </div>
                </div>
            </div> */}

            <div id="coreDocumentTypefilterContainer" style={{ marginTop: '0px', marginLeft: '8px' }}>
                <Filter permission={assetsPermissionOptions} fields={createFilterOptions(fieldData)} sortFields={createSortFieldOptions(sortFieldData)} apiURL={apiURL} fetchData={fetchData} setNotify={setNotify} reload={reload} useCompanyId={true} totalLabel={totalLabel} tabName={'coreDocumentTypesTab'} />
            </div>


            <Divider />

            <div id="coreDocumentTypeTableContainer" className={toggleColumnPinning()}>
                <div >
                    <Table data={apiData} columns={getColumns()} hiddenColumns={generateHiddenColumns(columns)} viewRowData={viewRowData} isLoading={isLoading} />
                </div>
            </div>

            <ActionDialog
                open={open}
                mode={mode}
                onClose={handleClose}
                onSave={() => handleSave(formId, rowJsonData, saveDocumentTypeData)}
                title="Core Document Type Information"
                propertiesTabContent={<CoreDocumentTypePropertiesPanel formId={formId}
                    documentTypeSchemaRequired={getSchema(mode)[0]}
                    documentTypeSchemaOptional={getSchema(mode)[1]}
                    saveDocumentTypeData={saveDocumentTypeData}
                    formData={rowJsonData} handleFormChange={handleFormChange}
                    readOnly={readOnly} />
                }
                jsonDataName="document types"
                JSONTabContent={rowJsonData}
                handleJsonChange={handleJsonChange}
                saveButtonText={saveButtonText}
            />

            <ConfirmDialog
                title={confirmProps.title}
                open={confirmOpen}
                onClose={handleConfirmClose}
                setOpen={setConfirmOpen}
                cancelButtonText={confirmProps.cancelButtonText}
                confirmButtonText={confirmProps.confirmButtonText}
                onConfirm={confirmProps.confirmCallback}
            >
                {confirmProps.msg}
            </ConfirmDialog>

        </>
    );
}

export default CoreDocumentTypesTabPanel;